// Initialize Animate of Scroll
  AOS.init();
  window.addEventListener("load", AOS.refresh);

// Initialize ScrollTrigger for GSAP
  gsap.registerPlugin(ScrollTrigger);

// Global Video Popup
  document.addEventListener('DOMContentLoaded', function() {
    const videoToggles = document.querySelectorAll('.video-popup-toggle'); // Select all toggle elements
    const videoPopup = document.querySelector('.video-popup');
    const closeButton = document.querySelector('.close-button');
    const iframe = document.querySelector('#mathews-player');

    // Function to show the video popup
    function showPopup(videoSrc) {
      iframe.src = videoSrc;
      videoPopup.classList.add('show');
      document.body.style.overflow = 'hidden'; // Prevent body scrolling
    }

    // Function to hide the video popup
    function hidePopup() {
      videoPopup.classList.remove('show');
      iframe.src = ''; // Clear the video source to stop playback
      document.body.style.overflow = ''; // Restore body scrolling
    }

    // Loop through each video toggle and add click event listener
    videoToggles.forEach(function(videoToggle) {
      videoToggle.addEventListener('click', function() {
        const videoSrc = videoToggle.getAttribute('data-video-src'); // Get the video source from the clicked toggle
        showPopup(videoSrc); // Show the popup with the corresponding video source
      });
    });

    // Event listener for the close button
    closeButton.addEventListener('click', hidePopup);
  });

/* SWIPERS */

  // General Card Swiper - Image | Link | Title
    var swiper = new Swiper('.swiper .swiper-container', {
      slidesPerView: 1.15,
      spaceBetween: 10,
      scrollbar: {
        el: '.swiper .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper .swiper-next',
        prevEl: '.swiper .swiper-prev',
      },
      breakpoints: {
        500: {
          slidesPerView: 2.15,
        },
        800: {
          slidesPerView: 3.15,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3.15,
        },
        1500: {
          slidesPerView: 4.15,
        },
      },
    });
  
  // Wide Card Swiper
    var swiperWideCards = new Swiper('.swiper-wide-cards .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      initialSlide: 0,
      loopedSlides: 1,
      pagination: {
        el: '.swiper-wide-cards .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-wide-cards .swiper-next',
        prevEl: '.swiper-wide-cards .swiper-prev',
      },
      breakpoints: {
        800: {
          slidesPerView: 1.15,
          initialSlide: 0
        }
      }
    });

    document.querySelectorAll('.tab-nav h4').forEach(tab => {
      tab.addEventListener('click', function() {
        // Remove active class from all tabs and containers
        document.querySelectorAll('.tab-nav h4').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.swiper-container').forEach(c => c.classList.remove('active'));
    
        // Add active class to the clicked tab and corresponding container
        this.classList.add('active');
        document.getElementById('swiper-' + this.id).classList.add('active');
      });
    });

    document.querySelectorAll('.mobile-tab-nav-item').forEach(tab => {
      tab.addEventListener('click', function() {
        // Remove active class from all tabs and containers
        document.querySelectorAll('.mobile-tab-nav-item').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.swiper-container').forEach(c => c.classList.remove('active'));
    
        // Add active class to the clicked tab and corresponding container
        this.classList.add('active');
        document.getElementById('swiper-' + this.id).classList.add('active');
      });
    });

  // Collection Products Tab Swiper
    var swiperCollectionTab1 = new Swiper('.swiper-collections-products .swiper-tab-1', {
      spaceBetween: 40,
      slidesPerView: 1.5,
      scrollbar: {
        el: '.swiper-controls-collection-1 .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-collections-products .swiper-next',
        prevEl: '.swiper-collections-products .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1000: {
          slidesPerView: 4,
          spaceBetween: 20
        },
      }
    });

  // Collection Products Tab Swiper 2
    var swiperCollectionTab2 = new Swiper('.swiper-collections-products .swiper-tab-2', {
      spaceBetween: 20,
      slidesPerView: 1.5,
      scrollbar: {
        el: '.swiper-controls-collection-2 .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-collections-products .swiper-next',
        prevEl: '.swiper-collections-products .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1000: {
          slidesPerView: 4
        },
      }
    });

  // Collection Products Tab Swiper 3
    var swiperCollectionTab2 = new Swiper('.swiper-collections-products .swiper-tab-3', {
      spaceBetween: 20,
      slidesPerView: 1.5,
      scrollbar: {
        el: '.swiper-controls-collection-3 .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-collections-products .swiper-next',
        prevEl: '.swiper-collections-products .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1000: {
          slidesPerView: 4
        },
      }
    });

  // Collection Products Tab Nav Swiper
  var swiperCollectionTabsMobile = new Swiper('.swiper-collections-products .swiper-mobile-container', {
    spaceBetween: 40,
    slidesPerView: 'auto',
  });
    // Ensure the clicked slide is in view
    swiperCollectionTabsMobile.on('click', function () {
      if (swiperCollectionTabsMobile.clickedIndex !== undefined) {
        swiperCollectionTabsMobile.slideTo(swiperCollectionTabsMobile.clickedIndex, 300); 
      }
    });

  // Related Products Swiper
    var swiperRelatedProducts = new Swiper('.swiper-related-products .swiper-container', {
      spaceBetween: 20,
      slidesPerView: 1.5,
      scrollbar: {
        el: '.swiper-related-products .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-related-products .swiper-next',
        prevEl: '.swiper-related-products .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1000: {
          slidesPerView: 4
        },
      }
    });

  // Collection Page - Additional Collections Swiper
    var swiperAdditionalCollections = new Swiper('.collection-additional-collections .swiper-container', {
      spaceBetween: 10,
      slidesPerView: 1.05,
      scrollbar: {
        el: '.swiper-controls-collection-1 .swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
      
      }
    });

  // Swiper - Logo Slider
    var swiperLogoSlider = new Swiper('.logo-slider .swiper-container', {
      spaceBetween: 75,
      slidesPerView: 2.5,
      scrollbar: {
        el: '.logo-slider .swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.logo-slider .swiper-next',
        prevEl: '.logo-slider .swiper-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 3
        },

        1400: {
          slidesPerView: 4,
          spaceBetween: 100
        },
      }
    });
  


























  // Global Anchor Nav Swiper
  var anchorNavSwiper = new Swiper('.anchor-nav .swiper-container', {
    spaceBetween: 35,
    slidesPerView: 'auto',
    breakpoints: {
     
    }
  });
  
/* Site Interactions */
    // Mobile Menu

      // Toggle Menu Open/Close
        document.querySelector('.mobile-menu-toggle').addEventListener('click', function() {
          this.classList.toggle('active');
          document.querySelector('.header.mobile').classList.toggle('active');
        
          if (this.classList.contains('active')) {
            document.body.style.overflow = 'hidden'; // Disable scrolling
          } else {
            document.body.style.overflow = 'auto'; // Enable scrolling
          }
        });

        document.querySelectorAll('.header.mobile .parent').forEach(function(element) {
          element.addEventListener('click', function() {
            selectedId = this.id;
            document.querySelector('.child-links.' + selectedId).classList.add('active');
          });
        });
          
        document.querySelectorAll('.header.mobile .child').forEach(function(element) {
          element.addEventListener('click', function() {
            var dataName = this.getAttribute('data-name');
            if (dataName) {
                var matchingGrandchild = document.getElementById('grandchild-'+dataName);
                if (matchingGrandchild) {
                    matchingGrandchild.classList.add('active');
                }
            }
            // this.closest('.child-links').querySelector('.grandchild-links').classList.add('active');
          });
        });

        document.querySelectorAll('.header.mobile .back').forEach(function(element) {
          element.addEventListener('click', function() {
            this.parentElement.classList.remove('active');
          });
        });

        document.querySelector('.header.mobile .mobile-menu-toggle').addEventListener('click', function() {
          document.querySelectorAll('.header.mobile .child-links').forEach(element => {
            element.classList.remove('active');
          });
          document.querySelectorAll('.header.mobile .grandchild-links').forEach(element => {
            element.classList.remove('active');
          });
        });

    // Product Map Interactions
      document.addEventListener('DOMContentLoaded', function() {
      const points = document.querySelectorAll('.point-single');
      
      points.forEach(point => {
        point.addEventListener('click', function() {
          const id = this.id; // Get the id of the clicked point
          const mobileProduct = document.querySelector(`.mobile-single-product#${id}`); // Find the matching mobile-single-product
        
          if (this.classList.contains('active')) {
            // If this point is active, just remove the active class
            this.classList.remove('active');
          } else {
            // Remove active class from all points
            points.forEach(p => {
              p.classList.remove('active');
            });
    
            // Remove active class from all mobile-products
            document.querySelectorAll('.mobile-single-product').forEach(mobile => {
              mobile.classList.remove('active');
            });
    
            // Add active class to the clicked point
            this.classList.add('active');
            
            // Add active class to the matching mobile-product
            if (mobileProduct) mobileProduct.classList.add('active');
          }
        });
      });
      });

    // Dropdowns
      document.addEventListener('DOMContentLoaded', function() {
      const dropdownButtons = document.querySelectorAll('.dropdown-single button');    
      dropdownButtons.forEach(dropdownButton => {
        dropdownButton.addEventListener('click', function() {
          this.classList.toggle('show');
          this.nextElementSibling.classList.toggle('show');
        });
      });
      });




// Angle3D Customizer Actions
window.onload = function() {

  const paragraph = document.createElement('p');
  paragraph.textContent = "For final price and order details, please contact your local retailer.";
  
  // Create the Download PDF button
  const button = document.createElement('button');
  button.className = 'btn';
  button.id = 'download-pdf';
  button.textContent = 'DOWNLOAD PDF';

  // Create the link copy PDF button 
  const button2 = document.createElement('button');
  button2.className = 'btn';
  button2.id = 'bow-copy-share-link';
  button2.textContent = 'COPY SHARE LINK';

  // Create container div for buttons
  const buttonContainer = document.createElement('div');
  buttonContainer.className = 'custom-btn-wrapper';
  buttonContainer.appendChild(button);
  buttonContainer.appendChild(button2);

  // Select the target element
  const target = document.querySelector('.tda-customizer-customization-options-container');

  if (target) {

    // Wait for the shadow DOM element to load
    const checkShadowButton = setInterval(() => {
  
      const modelViewer = document.querySelector('tda-model-viewer'); // Parent element with shadowRoot

      if (modelViewer && modelViewer.shadowRoot) {
          // Access the shadow root
          const shadowButton = modelViewer.shadowRoot.querySelector('.pdf-export-container');

          if (shadowButton) {
              
            
              // Insert the button container after the target element
              target.insertAdjacentElement('afterend', buttonContainer);
              //add paragraph
              target.insertAdjacentElement('afterend', paragraph);
              // Add the event listener to the Download PDF button
              const downloadPdfButton = document.getElementById('download-pdf');
              const sharelinkButton = document.getElementById('bow-copy-share-link');

              // Add click event listener to the Download PDF button
              downloadPdfButton.addEventListener('click', () => {
                  shadowButton.click();
                  console.log('Shadow DOM button clicked!');
              });

              // Add click event listener to the Share Link button
              sharelinkButton.addEventListener('click', () => {
                  // Copy current URL to clipboard
                  navigator.clipboard.writeText(window.location.href);
                  
                  // Create and show "Link copied" text below button
                  const copiedText = document.createElement('span');
                  copiedText.textContent = 'Link copied';
                  copiedText.style.display = 'block';
                  copiedText.style.marginTop = '5px';
                  sharelinkButton.parentNode.insertBefore(copiedText, sharelinkButton.nextSibling);
                  
                  // Remove the copied text after 4 seconds
                  setTimeout(() => {
                      copiedText.remove();
                  }, 4000);
              });

              clearInterval(checkShadowButton); // Stop checking once shadow button is found
          }
      }
    }, 100); // Check every 100ms
  } else {
    console.error('Target element not found.');
  }
};
    
    
    





